import React from "react";
import Dropzone from 'react-dropzone'
import Cropper from 'react-cropper';
import Modal from "./Modal.jsx";
import 'cropperjs/dist/cropper.css'
import { dataURLtoFile } from "../utils/functions.js";
import { checkTranslation, translate } from "../utils/useful.js";
import ButtonAnimated from "./buttons/ButtonAnimated.jsx";
import ReactCrop, { centerCrop, makeAspectCrop, Crop, PixelCrop, convertToPixelCrop, } from 'react-image-crop'

class CustomDropZone extends React.Component {


    state = {

    }

    onImageLoad = (e) => {
        const { naturalWidth: width, naturalHeight: height } = e.currentTarget
        let info = this.props.information
        let ratio = info.ratio ? (info.ratio.split(':')[0] / info.ratio.split(':')[1]) : 1
        const crop = centerCrop(
            makeAspectCrop(
                {
                    // You don't need to pass a complete crop into
                    // makeAspectCrop or centerCrop.
                    unit: '%',
                    width: 100,
                },
                ratio,
                width,
                height
            ),
            width,
            height
        )

        console.log("Crop", crop)
        this.setState({ crop })
        //   setCrop(crop)
    }

    setCrop = (crop) => {
        this.setState({ crop })
    }


    render() {
        const dropzoneRef = React.createRef();
        let info = this.props.information

        return (
            <div className="h-100">

                <Dropzone
                    disabled={this.props.disabled}
                    ref={dropzoneRef}
                    multiple={false}
                    accept={info.accept ?? 'image/jpeg,image/png'}
                    onDrop={this.onDrop}
                    style={{ flex: 1, cursor: 'pointer', outline: 'none' }}
                >
                    {({ getRootProps, getInputProps }) => (

                        <div className=" w-100 h-100 outline-none cursor-pointer" {...getRootProps()}>
                            <input {...getInputProps()} />
                            {this.props.children}
                        </div>

                    )}

                </Dropzone>



                <Modal ref={el => this.croperModal = el} maxWidth={700} style={{}} className={'flexcc'} noScroll={true} modalContentClassName={'h-90'} marginBottom={'5%'} lockOverlay={true}>

                    <div className="pt-2 pb-3" style={{ backgroundColor: '#fff', borderRadius: 8, minWidth: 150 }}>
                        {/* <Cropper
                            ref={el => this.cropper = el}
                            src={this.state.image}
                            style={{ maxHeight: 400, maxWidth: '100%' }}
                            aspectRatio={info.ratio ? (info.ratio.split(':')[0] / info.ratio.split(':')[1]) : null}
                            guides={true}
                            zoomable={false}
                            background={true}
                            backgroundColor={"#fff"}
                        /> */}

                        <ReactCrop
                            ref={el => this.cropper = el}
                            src={this.state.image}
                            style={{ maxHeight: 400, maxWidth: '100%', minWidth: 150 }}
                            aspect={info.ratio ? (info.ratio.split(':')[0] / info.ratio.split(':')[1]) : 1}
                            // aspect={16 / 9}
                            guides={true}
                            zoomable={false}
                            background={true}
                            backgroundColor={"#fff"}
                            // onLoad={this.onImageLoad}
                            onChange={c => this.setCrop(c)}
                            onComplete={(c) => this.setState({ finalCrop: c })}
                            crop={this.state.crop}
                            circularCrop={info.circular}
                        >
                            
                            <img
                                ref={el => this.image = el}
                                alt="Crop me"
                                src={this.state.image}
                                className="w-100"
                                // style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                                onLoad={this.onImageLoad}
                            />
                        </ReactCrop>

                        <div className=" mld-auto mrd-auto  mt-2 mb-2" style={{ textAlign: 'center', marginBottom: 0 }}>
                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={() => { this._crop(); }}
                                title={translate('Crop image')}
                                icon='/assets/icons/angle-right-white2.svg'
                                textColor={'#fff'}
                                bg={this.props.colors ? this.props.colors.background : '#007aff'}
                            />
                            {/* <button onClick={() => { this.croperModal.hideModal(); this._crop(); }} style={{ borderRadius: 30, padding: '5px 15px', backgroundColor: '#202020', }}>
                                <p style={{ fontSize: 15, fontWeight: 'bold', color: '#fff' }}>{translate("Add Image")}</p>
                            </button> */}
                        </div>
                    </div>
                </Modal>



            </div>

        );
    }


    onDrop = (filesInputs) => {

        this.setState({ originalFiles: filesInputs })

        if (this.props.information.cropper) {
            // if (filesInputs[0].type == 'image/jpeg') {
            console.log(URL.createObjectURL(filesInputs[0]))
            this.setState({ crop: undefined })
            const reader = new FileReader()
            reader.addEventListener('load', () => {

                // console.log("reader.result?.toString()", reader.result?.toString())
                this.setState({ image: reader.result?.toString() || '' }, () => {
                    this.croperModal.showModal()
                })
            }
            )

            reader.readAsDataURL(filesInputs[0])


            // }
        } else {

            let newImages = []

            filesInputs.forEach(filesInput => {
                // if (filesInput.type == 'image/jpeg') {
                newImages.push(URL.createObjectURL(filesInput))
                // } else {
                //     newImages.push(null)
                // }
            });

            this.props.onDrop(filesInputs, newImages)
        }
    }



    async _crop() {

        const crop = this.state.finalCrop;
        const image = this.image;

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        // Calculate crop dimensions
        const cropX = crop.x * scaleX;
        const cropY = crop.y * scaleY;
        const cropWidth = crop.width * scaleX;
        const cropHeight = crop.height * scaleY;

        // Create a Blob containing the cropped image
        const response = await fetch(this.state.image);
        const imageBlob = await response.blob();
        // console.log(imageBlob)
        let originalFile = this.state.originalFiles[0]
        let type = originalFile?.type ?? 'image/png'

        const croppedImageBlob = await this.cropImageBlob(imageBlob, cropX, cropY, cropWidth, cropHeight, type);

        const dataURL = await this.blobToDataURL(croppedImageBlob);
        // let image = this.cropper.getCroppedCanvas().toDataURL('image/jpeg', 1)
        // console.log(croppedImageBlob)
        // console.log(dataURL)

        // images.push(dataURL)

        let extention = type == 'image/jpeg' ? 'jpeg' : 'png'

        let file = dataURLtoFile(dataURL, ('image.' + extention))
        // files.push(file)
        // console.log(file)

        this.props.onDrop([file], [dataURL])

        this.croperModal.hideModal();

        // this.props.changeFiles(files, this.props.headerkey, 'file')
    }



    blobToDataURL = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result); // The result is a DataURL
            reader.onerror = reject; // Handle errors
            reader.readAsDataURL(blob); // Convert Blob to DataURL
        });
    };


    cropImageBlob = (blob, x, y, width, height, type) => {
        return new Promise((resolve) => {
            const offScreenCanvas = new OffscreenCanvas(width, height);
            const ctx = offScreenCanvas.getContext('2d');
            const img = new Image();

            img.onload = () => {
                ctx.drawImage(img, x, y, width, height, 0, 0, width, height);
                offScreenCanvas.convertToBlob({
                    type: type,
                }).then(resolve);
            };

            img.src = URL.createObjectURL(blob);
        });
    };
    // _crop() {

    //     let image = this.cropper.getCroppedCanvas().toDataURL('image/jpeg', 1)
    //     console.log(image)
    //     // images.push(dataURL)
    //     let file = dataURLtoFile(image, 'image.jpg');
    //     // files.push(file)
    //     this.props.onDrop([file], [image])

    //     this.croperModal.hideModal();

    //     // this.props.changeFiles(files, this.props.headerkey, 'file')
    // }


}

export default CustomDropZone;
